module.exports = __webpack_public_path__ + "static/media/marca_poupatempo_balcao_unico_govbr.5c6b88f8.png";